// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Manager_buttonContainer__PSA4h"};